// "Not now", remembered per browser.
//
// Declining is not offered: an invitation is someone else's record, and there
// is no honest way for this browser to close it on their behalf — the inviter
// withdraws it from People & access. What this does is stop the banner asking
// again on every page of every session, which is the difference between a
// reminder and a nag.
//
// Local, deliberately: it is a display preference, not a fact about the
// invitation, and it must not survive as one. The invitation stays open, and
// /invitations still lists it after a "Not now" on another device.

const KEY = "simino.invitations.dismissed";

function read(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : [];
  } catch {
    // Blocked or corrupt storage: nothing is dismissed, which errs towards
    // showing the invitation rather than hiding one.
    return [];
  }
}

export function isDismissed(invitationId: string): boolean {
  return read().includes(invitationId);
}

export function dismissInvitation(invitationId: string): void {
  try {
    // Capped: this list only ever grows, and an invitation id that no longer
    // exists is dead weight in every future read.
    const next = [...new Set([invitationId, ...read()])].slice(0, 50);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Then it asks again next time, which is the harmless failure.
  }
}
